import { ObjectUtil } from "@mcleod/core";
import { ComponentPropDefinitions } from "../../base/ComponentProps";
import { MultiButtonPropDefinitions, MultiButtonProps } from "../multibutton/MultiButtonProps";

let saveButtonPropDefs: ComponentPropDefinitions;

export interface SaveButtonProps extends MultiButtonProps {
  allowSave: boolean;
  allowAddNew: boolean;
  allowClose: boolean;
}

export class SaveButtonPropDefinitions {
  public static getDefinitions(): ComponentPropDefinitions {
    if (saveButtonPropDefs == null) {
      saveButtonPropDefs = {
        ...ObjectUtil.deepCopy(MultiButtonPropDefinitions.getDefinitions())
      };
      saveButtonPropDefs.busyWhenDataSourceBusy.defaultValue = true;
      saveButtonPropDefs.caption.defaultValue = "Save";
      saveButtonPropDefs.backgroundColor.defaultValue = "primary";
      saveButtonPropDefs.color.defaultValue = "primary.reverse";
      saveButtonPropDefs.minWidth.defaultValue = 100;
    }
    return saveButtonPropDefs;
  }
}
